<script setup lang="ts">

import { Sparkline } from '@app/Components/Utilities';
import { formatDate } from '@library/Utilities';
import type { IHealthMonitorFeature } from '@domain/CarePlan/HealthMonitor/IHealthMonitorFeature';

const model = defineModel<IHealthMonitorFeature>( { required: true } );
const battery = model.value.batteryHealth;

</script>

<template>

    <div class="p-4 lg:p-6 grid grid-cols-2 bg-gray-850">

        <!-- LAST READING -->
        <div class="flex flex-col gap-2">
            <h1 class="3xl:text-xl">Battery Voltage</h1>
            <strong class="text-4xl 2xl:text-6xl text-primary-500 dark:text-current">
                    <span v-if="battery.hasData">
                        {{ battery.currentVoltage }}v
                    </span>
                    <span v-else class="opacity-50">
                        --v
                    </span>
                </strong>
            <div class="flex flex-col text-xs 3xl:text-base">
                <span class="uppercase opacity-60">Last Reading</span>
                <span v-if="battery.utcDateLastReading">
                        {{ formatDate( battery.utcDateLastReading, 'ddd D MMM - HH:mm' ) }}
                    </span>
                    <span v-else>
                        Not available
                    </span>
            </div>
        </div>

        <!-- SPARKLINE -->
        <div class="flex items-center w-full">
            <div class="flex items-center w-full h-[72px] 3xl:h-[104px]">
                <div class="absolute w-full h-px bg-gray-100 dark:bg-gray-750 top-1"></div>
                <div class="absolute w-full h-px bg-gray-100 dark:bg-gray-750 bottom-1"></div>
                <div class="absolute w-full h-px bg-gray-100 dark:bg-gray-750"></div>
                <Sparkline v-model="battery.sparkline" />
                <div class="absolute w-px top-0 -bottom-4 right-[7px] bg-primary-500 dark:bg-white">
                    <div class="w-[5px] h-2.5 absolute bottom-[2px] -left-[2px] rounded-sm bg-primary-500 dark:bg-white"></div>
                    <div class="absolute -right-4 -top-5 text-xs font-bold">
                        {{ battery.currentVoltage }}v
                    </div>
                </div>
            </div>
            <div class="absolute left-0 bottom-0 text-xs opacity-60">{{ battery.minVoltage }}v</div>
            <div class="absolute left-0 top-0 text-xs opacity-60">{{ battery.maxVoltage }}v</div>
        </div>

    </div>

</template>
